import BaseQuery from "@/stateManagement/BaseQuery";
import { singleton } from "tsyringe";

import ReviewsSummaryStore, {
    ReviewsSummaryState,
} from "../stores/ReviewsSummaryStore";

@singleton()
class ReviewsSummaryQuery extends BaseQuery<ReviewsSummaryState> {
    constructor(store: ReviewsSummaryStore) {
        super(store);
    }

    avgRate$ = this.select((state) => state.summary?.avgRate);
    count$ = this.select((state) => state.summary?.count);
    status$ = this.select((state) => state.status);
}

export default ReviewsSummaryQuery;
